export default {
      id: "lignes_bg-usage",
      viewBox: "0 0 3000 880",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#lignes_bg-usage",
      toString: function () {
        return this.url;
      }
    }